import {
    IDuvidaTecnicaRequest,
    IResponderDuvidaTecnicaRequest,
} from "../../../../Interfaces/AssistenciaTecnica/Atendimento/DuvidaTecnica/DuvidaTecnicaInterface";
import { IListarMotivoParalisarNaoProcedencia } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/MotivoNaoProcedencia/MotivoNaoProcedencia";
import {
    IListarMotivoParalisarManutencao,
    IParalisarManutencao,
} from "../../../../Interfaces/AssistenciaTecnica/Atendimento/ParalisarManutencao/ParalisarManutencaoInterfaces";
import { ISolicitacaoNaoProcedenteAvaliar } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/SolicitacaoNaoProcedente/SolicitacaoNaoProcedente";
import {
    IVistoriaExecutada,
    TiposVistoria,
} from "../../../../Interfaces/AssistenciaTecnica/Atendimento/VistoriaProcedente/VistoriaProcedenteInterface";
import { ACESSOS } from "../../../../Routes/Acessos";
import {
    VerificaExisteAgendamentoService,
    AvancarEtapaTipoCasoDeAtendimentoService,
    DuvidaTecnicaService,
    ListarMotivoNaoProcedenciaService,
    ListarMotivoParalisarService,
    ManutencaoNaoConcluidaService,
    ParalisarAtendimentoService,
    ReiniciarAtendimentoService,
    ResponderDuvidaTecnicaService,
    SolicitacaoNaoProcedenteService,
    TecnicoNaoCompareceuService,
    ValidarSolicitacaoNaoProcedenteService,
    VistoriaNaoRealizadaService,
    VistoriaExecutadaSolicitacaoProcedenteService,
    FechamentoSolicitacaoService,
    AvancarSemResponderPesquisaServices,
    ReenviarEmailPesquisaSatisfacaoServices,
    ResultadoVistoriaService,
    DeletarMotivoParalisarService,
    InserirMotivoParalisarService,
    EditarMotivoParalisarService,
    ObterMotivoParalisarService,
    ListagemDosMotivoNaoProcedenciaService,
    ObterMotivoNaoProcedenciaService,
    CadastrarMotivoNaoProcedenciaService,
    EditarMotivoNaoProcedenciaService,
    DeletarMotivoNaoProcedenciaService,
} from "../../../../Services/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoServices";
import { Controller } from "../../../Controller";

export async function AvancarEtapaTipoCasoDeAtendimentoController(
    idCaso: number
) {
    return Controller(AvancarEtapaTipoCasoDeAtendimentoService(idCaso));
}

export async function VerificaExisteAgendamentoController(idCaso?: number) {
    return Controller(VerificaExisteAgendamentoService(idCaso));
}
export async function DuvidaTecnicaController(
    idCaso: number,
    requestBody: IDuvidaTecnicaRequest
) {
    return Controller(DuvidaTecnicaService(idCaso, requestBody));
}

export async function ResponderDuvidaTecnicaController(
    idCaso: number,
    requestBody: IResponderDuvidaTecnicaRequest
) {
    return Controller(ResponderDuvidaTecnicaService(idCaso, requestBody));
}

export async function TecnicoNaoCompareceuController(
    idCaso: number,
    etapaTipoCaso: number,
    ClienteVisualizaHistorico: boolean
) {
    return Controller(
        TecnicoNaoCompareceuService(
            idCaso,
            etapaTipoCaso,
            ClienteVisualizaHistorico
        )
    );
}

export async function VistoriaNaoRealizadaController(
    idCaso: number,
    flEmpresa: "Cliente" | "Empresa"
) {
    return Controller(VistoriaNaoRealizadaService(idCaso, flEmpresa));
}

export async function ListarMotivoParalisarController() {
    return Controller(ListarMotivoParalisarService());
}

export async function ObterMotivoParalisarController(
    idMotivoParalizacao: number
) {
    return Controller(ObterMotivoParalisarService(idMotivoParalizacao));
}

export async function DeletarMotivoParalisarController(
    idMotivoParalizacao: number
) {
    return Controller(DeletarMotivoParalisarService(idMotivoParalizacao));
}

export async function InserirMotivoParalisarController(
    requestBody: IListarMotivoParalisarManutencao
) {
    return Controller(InserirMotivoParalisarService(requestBody));
}

export async function EditarMotivoParalisarController(
    requestBody: IListarMotivoParalisarManutencao
) {
    return Controller(EditarMotivoParalisarService(requestBody));
}

export async function ParalisarAtendimentoController(
    requestBody: IParalisarManutencao
) {
    return Controller(ParalisarAtendimentoService(requestBody));
}

export async function ReiniciarAtendimentoController(idCaso: number) {
    return Controller(ReiniciarAtendimentoService(idCaso));
}

export async function MotivoNaoProcedenciaController(idCaso: number) {
    return Controller(ListarMotivoNaoProcedenciaService(idCaso));
}

export const ListarMotivoNaoProcedenciaController = async () =>
    MotivoNaoProcedenciaController(ACESSOS.ASSISTENCIA.ID_MODULO);

export async function SolicitacaoNaoProcedenteController(
    tipoSolicitacao: "ConstrutoraAvaliara" | "FinalizarSolicitacao",
    requestBody: ISolicitacaoNaoProcedenteAvaliar
) {
    return Controller(
        SolicitacaoNaoProcedenteService(tipoSolicitacao, requestBody)
    );
}

export async function FechamentoSolicitacaoController(
    requestBody?: ISolicitacaoNaoProcedenteAvaliar
) {
    return Controller(FechamentoSolicitacaoService(requestBody));
}

export async function ManutencaoNaoConcluidaController(idCaso: number) {
    return Controller(ManutencaoNaoConcluidaService(idCaso));
}

export async function ValidarSolicitacaoNaoProcedenteController(
    idCaso: number
) {
    return Controller(ValidarSolicitacaoNaoProcedenteService(idCaso));
}

export async function VistoriaExecutadaSolicitacaoProcedenteController(
    idCaso: number,
    tipoVistoria: TiposVistoria,
    requestBody: IVistoriaExecutada
) {
    return Controller(
        VistoriaExecutadaSolicitacaoProcedenteService(
            idCaso,
            tipoVistoria,
            requestBody
        )
    );
}

export async function AvancarSemResponderPesquisaController(idCaso: number) {
    return Controller(AvancarSemResponderPesquisaServices(idCaso));
}

export async function ReenviarEmailPesquisaSatisfacaoController(
    idCaso: number
) {
    return Controller(ReenviarEmailPesquisaSatisfacaoServices(idCaso));
}

export async function ResultadoVistoriaController(
    ID_CASO: number,
    RESULTADO: string
) {
    return Controller(ResultadoVistoriaService(ID_CASO, RESULTADO));
}

export async function ListagemDosMotivoNaoProcedenciaController() {
    return Controller(ListagemDosMotivoNaoProcedenciaService());
}

export async function ObterMotivoNaoProcedenciaController(
    idMotivoNaoProcedencia: number
) {
    return Controller(ObterMotivoNaoProcedenciaService(idMotivoNaoProcedencia));
}

export async function CadastrarMotivoNaoProcedenciaController(
    requestBody: IListarMotivoParalisarNaoProcedencia
) {
    return Controller(CadastrarMotivoNaoProcedenciaService(requestBody));
}

export async function EditarMotivoNaoProcedenciaController(
    requestBody: IListarMotivoParalisarNaoProcedencia
) {
    return Controller(EditarMotivoNaoProcedenciaService(requestBody));
}

export async function DeletarMotivoNaoProcedenciaController(
    idMotivoNaoProcedencia: number
) {
    return Controller(
        DeletarMotivoNaoProcedenciaService(idMotivoNaoProcedencia)
    );
}
